<div class="checkbox" [formGroup]="form">
    <mat-checkbox [formControl]="field">{{ label }}</mat-checkbox>
</div>
